import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationPanel } from "@/shared/types";

export const useSelectedPanelIndex = (panels: NavigationPanel[], defaultIndexPaths: string = "") => {
	const location = useLocation();
	const navigate = useNavigate();

	const [currentSelectedIndex, setCurrentSelectedIndex] = useState<number>(0);

	const handlePanelClick = (index: number) => {
		if (!panels[index as number].route) {
			navigate(`${defaultIndexPaths}`);

			return;
		}
		navigate(`${defaultIndexPaths}/${panels[index as number].route}`);
	};

	useEffect(() => {
		if (defaultIndexPaths.includes(location.pathname)) {
			setCurrentSelectedIndex(0);
			return;
		}

		const currentPath = location.pathname.split("/").pop();
		const currentIndex = panels.findIndex((panel) => panel.route === currentPath);

		if (currentIndex !== -1) {
			setCurrentSelectedIndex(currentIndex);
		}
	}, [location, panels, defaultIndexPaths]);

	return { currentSelectedIndex, handlePanelClick };
};
